import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";
import * as firebase from "firebase";

export default (action$) =>
  action$.ofType(Types.UPDATE_QUEUE_ORDER).mergeMap(async (action) => {
    try {
      const { location, queueUsers } = action;

      for (const [index, registration] of queueUsers.entries()) {
        await firebase
          .database()
          .ref(`queues/${location}/${registration.registrationId}`)
          .update({ reorderIndex: index });
      }

      return Creators.updateQueueOrderSucceeded();
    } catch (error) {
      console.error(error);
      return Creators.updateQueueOrderFailed();
    }
  });



// WEBPACK FOOTER //
// ./src/staff/epics/updateQueueOrder.js